import React from 'react'
import { Helmet } from 'react-helmet-async'
import { motion } from 'framer-motion'
import { FileText, AlertTriangle, Scale, Shield, Users, Globe } from 'lucide-react'

const TermsOfService: React.FC = () => {
  const sections = [
    {
      title: '1. 服务条款接受',
      icon: FileText,
      content: [
        '本服务条款（"条款"）是您与DeepLink Limited（"我们"、"本公司"）之间的法律协议。',
        'DeepLink Limited是一家根据香港法律注册成立的公司，注册地址为香港中环国际金融中心二期。',
        '使用我们的服务、网站或CoreTrust手机产品即表示您同意受本条款约束。',
        '如果您不同意本条款的任何部分，请停止使用我们的服务。'
      ]
    },
    {
      title: '2. 服务描述',
      icon: Globe,
      content: [
        '我们提供CoreTrust手机及相关Web3服务，包括但不限于：',
        '• 熄屏广告系统',
        '• 空投助手功能',
        '• 数字银行服务',
        '• 硬件级钱包',
        '• 应用市场',
        '• 去中心化网络通话',
        '我们保留随时修改、暂停或终止任何服务的权利。',
        '服务可能因技术维护、升级或其他原因暂时中断。'
      ]
    },
    {
      title: '3. 用户责任和义务',
      icon: Users,
      content: [
        '您必须年满18岁或达到您所在司法管辖区的法定成年年龄才能使用我们的服务。',
        '您同意：',
        '• 提供真实、准确、完整的注册信息',
        '• 及时更新您的信息以保持准确性',
        '• 妥善保管您的账户凭据',
        '• 不得将账户转让给他人',
        '• 不得使用我们的服务进行非法活动',
        '• 不得干扰或破坏我们的服务',
        '• 遵守所有适用的法律法规'
      ]
    },
    {
      title: '4. 知识产权',
      icon: Scale,
      content: [
        '我们拥有或获得许可使用我们服务中的所有知识产权，包括但不限于：',
        '• 商标、商号、标识',
        '• 软件、算法、技术',
        '• 内容、设计、界面',
        '• 专利、版权、商业秘密',
        '您不得复制、修改、分发、出售或租赁我们的知识产权。',
        '您保留对您提交给我们的内容的所有权利，但授予我们使用这些内容的必要许可。'
      ]
    },
    {
      title: '5. 隐私和数据保护',
      icon: Shield,
      content: [
        '我们按照我们的隐私政策收集、使用和保护您的个人资料。',
        '隐私政策构成这些条款的一部分。',
        '我们遵守香港《个人资料（私隐）条例》的规定。',
        '您同意我们按照隐私政策处理您的个人资料。',
        '我们采用适当的技术和组织措施保护您的资料安全。'
      ]
    },
    {
      title: '6. 免责声明',
      icon: AlertTriangle,
      content: [
        '在法律允许的最大范围内，我们的服务按"现状"提供，不提供任何明示或暗示的保证。',
        '我们不保证：',
        '• 服务将不间断或无错误',
        '• 服务将满足您的特定需求',
        '• 服务中的信息将准确或完整',
        '• 服务将安全或无病毒',
        '您使用我们的服务风险自负。',
        '我们不对因使用或无法使用我们的服务而造成的任何直接、间接、偶然或后果性损害承担责任。'
      ]
    },
    {
      title: '7. 责任限制',
      icon: Scale,
      content: [
        '在法律允许的最大范围内，我们的总责任不超过您在过去12个月内向我们支付的费用。',
        '我们不承担以下类型的损害：',
        '• 利润损失、收入损失或业务机会损失',
        '• 数据丢失或损坏',
        '• 间接、偶然或后果性损害',
        '• 第三方索赔',
        '某些司法管辖区不允许限制或排除某些责任，因此上述限制可能不适用于您。'
      ]
    },
    {
      title: '8. 服务终止',
      icon: FileText,
      content: [
        '您可以随时停止使用我们的服务。',
        '我们可以在以下情况下暂停或终止您的账户：',
        '• 您违反本条款',
        '• 您从事非法或有害活动',
        '• 法律要求我们这样做',
        '• 我们决定停止提供服务',
        '终止后，您访问我们服务的权利将立即停止。',
        '我们保留删除您账户中所有数据的权利。'
      ]
    },
    {
      title: '9. 争议解决',
      icon: Scale,
      content: [
        '本条款受香港法律管辖并按其解释。',
        '因本条款或我们的服务产生的任何争议应通过以下方式解决：',
        '• 首先通过友好协商解决',
        '• 如协商不成，提交香港国际仲裁中心仲裁',
        '• 仲裁程序应按照香港国际仲裁中心规则进行',
        '• 仲裁地点为香港',
        '• 仲裁语言为中文或英文',
        '仲裁裁决为终局裁决，对双方均有约束力。'
      ]
    },
    {
      title: '10. 条款修改',
      icon: FileText,
      content: [
        '我们可能会不时修改本条款。',
        '重大修改将通过以下方式通知您：',
        '• 在我们的网站上发布通知',
        '• 通过电邮发送通知',
        '• 通过CoreTrust手机应用推送通知',
        '继续使用我们的服务即表示您接受修改后的条款。',
        '如您不同意修改后的条款，可以停止使用我们的服务。',
        '建议您定期查看本条款的最新版本。'
      ]
    }
  ]

  return (
    <>
      <Helmet>
        <title>服务条款 - DeepLink Limited</title>
        <meta name="description" content="DeepLink Limited服务条款，受香港法律管辖" />
      </Helmet>

      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-12">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="max-w-4xl mx-auto"
          >
            <div className="text-center mb-12">
              <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
                服务条款
              </h1>
              <p className="text-gray-600 dark:text-gray-400 mb-4">
                最后更新：2024年1月1日 | 生效日期：2024年1月1日
              </p>
              <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg p-4 max-w-2xl mx-auto">
                <p className="text-sm text-yellow-800 dark:text-yellow-200">
                  <strong>重要提示：</strong>本服务条款受香港法律管辖。使用我们的服务即表示您同意受本条款约束。
                </p>
              </div>
            </div>

            <div className="space-y-8">
              {sections.map((section, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6"
                >
                  <div className="flex items-center mb-4">
                    <div className="w-10 h-10 bg-blue-100 dark:bg-blue-900/30 rounded-lg flex items-center justify-center mr-4">
                      <section.icon className="w-5 h-5 text-blue-600 dark:text-blue-400" />
                    </div>
                    <h2 className="text-2xl font-semibold text-gray-900 dark:text-white">
                      {section.title}
                    </h2>
                  </div>
                  <div className="space-y-3">
                    {section.content.map((item, itemIndex) => (
                      <p key={itemIndex} className="text-gray-700 dark:text-gray-300 leading-relaxed">
                        {item}
                      </p>
                    ))}
                  </div>
                </motion.div>
              ))}
            </div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.8 }}
              className="mt-12 bg-gray-100 dark:bg-gray-800 rounded-lg p-6"
            >
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                联系我们
              </h3>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                如果您对本服务条款有任何疑问，请通过以下方式联系我们：
              </p>
              <div className="space-y-2">
                <p className="text-gray-700 dark:text-gray-300">
                  <strong>电邮：</strong> legal@deeplink.hk
                </p>
                <p className="text-gray-700 dark:text-gray-300">
                  <strong>电话：</strong> +852 1234-5678
                </p>
                <p className="text-gray-700 dark:text-gray-300">
                  <strong>地址：</strong> 香港中环国际金融中心二期
                </p>
                <p className="text-gray-700 dark:text-gray-300">
                  <strong>注册办事处：</strong> 香港中环国际金融中心二期
                </p>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </>
  )
}

export default TermsOfService